// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { imageStyles } from "@guestsupply/Overrides/Widgets/BrandDetails/BrandDetailsImage";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const commonTypographyStyles: TypographyProps = {
    size: 16,
    weight: 400,
    css: css`
        margin-bottom: 0;
    `,
};

imageStyles.productLinkItem = {
    width: 6,
    css: css`
        justify-content: flex-end;
        padding-right: 15px;
    `,
};

imageStyles.fullWidthProductLinkItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};

imageStyles.externalLinkItem = {
    width: 6,
    css: css`
        padding-left: 15px;
        justify-content: flex-start;
    `,
};

imageStyles.linksContainer = {
    gap: 0,
    css: css`
        margin-bottom: 50px;
    `,
};

imageStyles.externalLink = {
    typographyProps: commonTypographyStyles,
    css: css`
        text-transform: capitalize;
    `,
};

imageStyles.productLink = {
    typographyProps: commonTypographyStyles,
    css: css`
        text-transform: capitalize;
    `,
};

imageStyles.container = {
    gap: 0,
};

imageStyles.imageItem = {
    width: 6,
    css: css`
        margin-bottom: 50px;
        justify-content: flex-end;
        padding-right: 15px;
    `,
};

imageStyles.htmlItem = {
    width: 6,
    css: css`
        padding-left: 15px;
        margin-bottom: 50px;
    `,
};

imageStyles.image = {
    css: css`
        height: 300px;
        width: 500px;
        img {
            max-width: 100%;
            max-height: 100%;
            height: auto;
        }
    `,
};

imageStyles.linksItem = {
    width: 12,
};

imageStyles.imageMissingText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        overflow-wrap: break-word;
        word-wrap: break-word;
    `,
};
